import Accordion from "@/common/components/Accordion";
import { SuggestionData } from "@/common/types/highlightTextArea.type";
import { cn } from "@/common/utils/cn";
import { Fragment, useId, useMemo } from "react";

interface AvailableTokensAccordionProps {
  descriptionTokens?: SuggestionData[],
  updatedAt?: number
}

export function AvailableTokensAccordion({ descriptionTokens, updatedAt }: AvailableTokensAccordionProps) {
  const uniqueId = useId()

  const groupedByPrefix = useMemo(() => {
    return descriptionTokens?.reduce((prev, curr) => {
      const prefix = curr.label!.split('.')[0];

      return {
        ...prev,
        [prefix]: [
          ...(prev.hasOwnProperty(prefix) ? prev[prefix] : []),
          curr,
        ]
      }
    }, {} as any) || {}
  }, [updatedAt]);

  return (
    <Accordion
      className="py-1"
      head={<p>Tokens disponíveis para uso</p>}
      body={
        <div className="flex flex-col gap-3 text-white-800">
          {groupedByPrefix && Object.keys(groupedByPrefix).map((prefix, index) => (
            <Fragment key={prefix}>
              {index > 0 && <div className="h-px w-full bg-white-300/10" />}

              <div className="flex flex-col gap-2">
                <p className="font-semibold text-white-800 text-[16px]">@{prefix}</p>

                <div className="flex flex-col gap-1">
                  {(groupedByPrefix[prefix] || [])?.map((data: SuggestionData, i: number) => (
                    <div className="flex flex-wrap gap-x-2" key={uniqueId + i}>
                      <span className="text-[#FC9CE0] text-sm">
                        @{data.value}
                      </span>

                      <span className="text-white-400 text-sm">
                        {data.description}
                      </span>

                      <span className={cn("text-white-300 italic font-light", data.example?.includes('\n') && 'basis-[100%]')} style={{ whiteSpace: "pre-wrap" }}>
                        Ex: {data.example}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </Fragment>

          ))}
        </div>
      }
    />
  )
}
